import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import IconButton from '~src/shared/buttons/IconButton/IconButton';
import ActionConfirmDialog from '~src/shared/dialogs/actionConfirmDialog/ActionConfirmDialog';
import SvgIcon from '~src/shared/SvgIcon';
import useDeleteAdminFeedbackCycle from '~src/hooks/api/adminFeedback/useDeleteAdminFeedbackCycle';
import { useDispatch } from 'react-redux';
import { showNotification } from '~src/store/app/actions';
import feedbackCycleCache from '~src/hooks/api/adminFeedback/cache';

interface DeleteFeedbackCycleDialogProps {
  feedbackCycleId: string;
}

const DeleteFeedbackCycleDialog = ({ feedbackCycleId }: DeleteFeedbackCycleDialogProps) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [isOpen, setOpen] = useState(false);

  const { mutate: deleteAdminFeedbackCycle } = useDeleteAdminFeedbackCycle();

  return (
    <div
      style={{ position: 'absolute', right: '32px' }}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        console.log('feedbackCycleId: ', feedbackCycleId);
      }}
    >
      <IconButton iconType="danger" onClick={() => setOpen(true)}>
        <div>
          <SvgIcon name="iconBin" />
        </div>
      </IconButton>

      <ActionConfirmDialog
        t={t}
        show={isOpen}
        close
        onHide={() => setOpen(false)}
        actionTitleKey={t('x.admin.feedback.cycle.confirm.delete.title')}
        actionContentKey={t('x.admin.feedback.cycle.confirm.delete.title.description')}
        actionCall={() => {
          deleteAdminFeedbackCycle(feedbackCycleId, {
            onSuccess: () => {
              feedbackCycleCache.deleteFeedbackCycle(feedbackCycleId);
              dispatch(
                showNotification({
                  id: 'feedback_cycle_deleted',
                  txtKey: 'x.admin.feedback.cycle.confirm.delete.success',
                }),
              );
              setOpen(false);
            },
          });
        }}
        showDeletion
        loadingAction={false}
      />
    </div>
  );
};

export default DeleteFeedbackCycleDialog;
